import { ApaStatus } from '../../../types/graphql-global-types';
import { GetUserInfos_getUser } from '../../../graphql/user/types/GetUserInfos';

export interface IEchelon {
  id: number;
  name: string | null | undefined;
  priority: number | null | undefined;
}

export interface IEntity {
  id: number;
  name: string;
  managed?: boolean;
  echelon?: IEchelon;
}

export interface ICommission {
  id: number;
  beneficiary: {
    id: number;
    firstName: string;
    lastName: string | null;
  } | null;
  amount: number | null;
  isNew: boolean;
}

export interface IEnseigne {
  id: number;
  name: string;
  entities?: IEntity[];
}

export interface IUserEditState {
  userId: number;
  createdAt: any;
  avatarUrl: string | null;
  firstName?: string | null;
  lastName?: string | null;
  phone?: string | null;
  email?: string | null;
  apaStatus?: ApaStatus | null;
  siren?: string | null;
  rib?: string | null;
  secu?: string | null;
  roles: string[];
  userEnseigne: IEnseigne | null;
  entities: IEntity[] | null;
  defaultCommissionDistributions: ICommission[] | null;
  totalDefaultCommission: number;
  function: string | null;
  iban?: string;
  idCRM: number | null;
  civility: string | null;
}

export const initialUserState: IUserEditState = {
  userId: 0,
  createdAt: '',
  avatarUrl: '',
  firstName: '',
  lastName: '',
  phone: '',
  email: '',
  apaStatus: ApaStatus.INDEPENDANT,
  siren: '',
  rib: '',
  secu: '',
  roles: [],
  userEnseigne: null,
  entities: [],
  defaultCommissionDistributions: [],
  totalDefaultCommission: 0,
  function: '',
  iban: '',
  idCRM: null,
  civility: null,
};

export const mapUserDataToState = (
  userData: GetUserInfos_getUser,
): IUserEditState => {
  const {
    __typename,
    id,
    enseigne,
    entities,
    enseigneName,
    totalDefaultCommission,
    defaultCommissionDistributions,
    iban,
    mandatary,
    ...basicInfos
  } = userData;
  const userState: IUserEditState = {
    ...basicInfos,
    userId: id,
    totalDefaultCommission: totalDefaultCommission || 0,
    iban: iban ?? undefined,
    userEnseigne: enseigne
      ? {
          id: enseigne.id,
          name: enseigne.name,
          entities: enseigne.entities
            ? enseigne.entities.map((entity) => ({
                id: entity.id,
                name: entity.name || '',
                managed: entity.managers?.some((manager) => manager.id === id),
                echelon: {
                  id: entity.echelon.id,
                  name: entity.echelon.name,
                  priority: entity.echelon.priority,
                },
              }))
            : [],
        }
      : null,
    defaultCommissionDistributions:
      defaultCommissionDistributions &&
      defaultCommissionDistributions?.map((commission) => ({
        ...commission,
        isNew: false,
      })),
    entities: entities
      ? entities.map((entity) => ({ id: entity.id, name: entity.name || '' }))
      : [],
  };

  return userState;
};
